import styled from 'styled-components';
import { Typography, Input, Space, Row, Image } from 'antd';

const { Title } = Typography;
const { Search } = Input;

const StyledTitle = styled(Title)`
  color: #4b4b4b !important;
  &&& {
    font-weight: normal;
    margin-top: 5px;
    margin-left: 25px;
  }
`;

const StyledSearch = styled(Search)`
  &&& {
    width: 350px;
  }
`;

const StyledSpace = styled(Space)`
  &&& {
    min-width: max-content;
    width: 100% !important;
    gap: 0px !important;
  }
`;

const StyledRow = styled(Row)`
  &&& {
    border-bottom: 1px solid #0078d4;
    margin-bottom: 5px;
  }
`;

const StyledImage = styled(Image)`
  &&& {
    width: 45px;
    margin-right: 15px;
  }
`;

export { StyledTitle, StyledSearch, StyledSpace, StyledRow, StyledImage };
